'use client';

import { c as _c } from "react/compiler-runtime";
import { addAddress, getPodsAddressIdFromResponse, type UpdateShippingAddressRequest, updateShippingAddress } from '@libs/api-proxy-client';
import { SubscriptionOrder, useUserSession } from '@libs/common-next';
import { PROFILE_DATA } from '@libs/shared-ui';
const convertSubscriptionAddressToPayload = (addressData: UpdateShippingAddressRequest) => {
  return {
    firstName: addressData.firstName,
    lastName: addressData.lastName,
    countryAbbreviation: addressData.country,
    stateProvinceAbbreviation: addressData.state,
    zipPostalCode: addressData.postalCode,
    city: addressData.city,
    streetLine1: addressData.line1,
    streetLine2: addressData.line2,
    isActive: true,
    isPrimary: false,
    phoneNumber: addressData.phone,
    addressType: 'other'
  };
};
export const useAddressManager = () => {
  const $ = _c(2);
  const {
    updateProfileData
  } = useUserSession();
  let t0;
  if ($[0] !== updateProfileData) {
    const createNewAddress = async subscriptionAddress => {
      const payload = convertSubscriptionAddressToPayload(subscriptionAddress);
      const response = await addAddress(payload);
      if (!response) {
        throw new Error("Address API request failed");
      }
      if (response && updateProfileData) {
        await updateProfileData?.(PROFILE_DATA.ADDRESSES);
        await updateProfileData?.(PROFILE_DATA.PROFILE);
      }
      return getPodsAddressIdFromResponse(response);
    };
    const linkAddressToOG = _temp2;
    t0 = {
      createNewAddress,
      linkAddressToOG
    };
    $[0] = updateProfileData;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
};
function _temp(subscriptionIds, item) {
  if (item.subscription) {
    subscriptionIds.push(item.subscription.id);
  }
  return subscriptionIds;
}
async function _temp2(addressData, order) {
  const orderId = order.id;
  const orderSubscriptions = order.items.reduce(_temp, []);
  await updateShippingAddress([orderId], orderSubscriptions, addressData);
}